import type { TSetTranslationKeys } from '@crehana/ts-types';

import type es from './localeEs';

export type TKeys = TSetTranslationKeys<typeof es>;

type TTranslations = { en: Record<TKeys, string> };

const localeEn: TTranslations = {
  en: {
    MENU_ROUTE_HOME: 'Home',
    MENU_ROUTE_HANA_AI: 'Crehana AI',
    MENU_ROUTE_HANA_AI_ASSISTANT: 'Assistant',
  },
};

export default localeEn;
